import GLightbox from 'glightbox';

export default ({app}, inject) => {
    inject('lightbox', GLightbox({
        touchNavigation: true,
        selector: '.lightbox',
    }));
}
